import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import '@yandex-360/orb-themes/css/orb-light.css';
import '@yandex-360/orb-themes/css/brands/calendar.css';
import '@yandex-360/orb-themes/css/brands/concept.css';
import '@yandex-360/orb-themes/css/brands/disk.css';
import '@yandex-360/orb-themes/css/brands/docs.css';
import '@yandex-360/orb-themes/css/brands/forms.css';
import '@yandex-360/orb-themes/css/brands/mail.css';
import '@yandex-360/orb-themes/css/brands/telemost.css';
import '@yandex-360/orb-themes/css/brands/tracker.css';
import '@yandex-360/orb-themes/css/brands/wiki.css';
import './fonts.css';
import './index.css';
import App from './components/App';
import { store } from './store';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);
